import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import type { ElementType } from 'react'
import { twMerge } from 'tailwind-merge'

const buttonVariants = cva('button', {
    variants: {
        variant: {
            default: 'button-default',
            cta: 'button-cta',
            text: 'button-text',
        }
    },
    defaultVariants: {
        variant: 'default',
    },
})

export interface ButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
    Icon?: ElementType
    as?: React.ElementType
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            className,
            variant,
            children,
            as = 'button',
            Icon,
            ...props
        },
        ref,
    ) => {

        const Comp = as
        return (
            <Comp
                className={twMerge(buttonVariants({ variant }), className)}
                ref={ref}
                {...props}
            >
                {children}
                {Icon && <Icon className="h-5 w-5 stroke-[2px]" aria-hidden="true" />}
            </Comp>
        )
    },
)
Button.displayName = 'Button'

export { Button, buttonVariants }
